<template>
  <div>
    
    <crm-toolbar :dbView="102" :pageName="'activitytab'" :label="'Task or Event'" :customer="customer" @changeData="updateActivities" @newInstance="newActivity" @fetchedColSelectedFields="updateColSelectedFields" @setDefaultViewFields="setDefaultViewFields"/>

    <ActivityDataTable
      recordsLabel="Tasks & Events"
      :dbView="dbView"
      :colSelectedFieldsForTable="colSelectedFieldsForTable"
      :colSelectedFields="colSelectedFields"
      :activities="activities"
      :dbViewFields="dbViewFields"
      :loading="loadingActivities"
      :filters1="filters"
      @confirmDeleteActivity="confirmDeleteActivity"
      @editActivity="editActivity"
      @reload="reload"
      @reloadCols="reloadCols" 
    />

    <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you want to proceed?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text"/>
        <Button label="Yes" icon="pi pi-check" @click="confirmDeleteActivity" class="p-button-text" autofocus />
      </template>
    </Dialog>

    <!-- Dialog to Create & Edit an Activity -->
    
    <ActivityForm
      v-if="activityDialog"
      :key="activityFormKey"
      :activityForm="activityDialog"
      mode="auto"
      :activityToEdit="activity"
      :disabledArr="disabledArr"
      @close="close"
      @saved="savedActivity"
    />
    
  </div>
</template>
<script>
import CustomerService from "@/service/CustomerService";
import FiltersService from "@/service/FiltersSerice";
import ActivityService from "@/service/ActivityService";

import ActivityForm from "@/mbp/universalComponents/activity/ActivityForm.vue";
import ActivityDataTable from "@/mbp/universalComponents/myActivity/MyActivityTableForLazyLoadingWithResize.vue";

import crmToolbar from '../../universalComponents/general/crmToolbar'
import { recordNoun } from "@/mbp/activityKind";

import {
  activityRequest
} from '../../universalComponents/sendRequest'

export default {
  components: {
    ActivityForm,
    ActivityDataTable,
    crmToolbar
  },
  props: ["customer"],
  customerService: null,
  filtersService: null,
  activityService: null,
  data: () => ({
    filters: {},
    activities: [],
    activityDialog: false,
    activity: {},
    disabledArr: [],
    activityFormKey1: 0,
    displayConfirmation: false,
    requesting: false,
    dbView: 102,
    colSelectedFieldsForTable: [],
    colSelectedFields: [],
    defaultView: false,
    dbViewFields: [],
    sendingRequest: false,

    loadingActivities: false,
    activities: [],
    reloadTableE: 0,
  }),
  computed: {
    activityFormKey: {
      set(val) {
        this.activityFormKey1++
      },
      get() {
        return 'activityForm' + this.activityFormKey1.toString()
      }
    },
    loading() {
      if (this.activities && this.activities[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.customerService = new CustomerService();
    this.filtersService = new FiltersService();
    this.activityService = new ActivityService();
  },
  watch: {
    colSelectedFieldsForTable(val) {
      this.contactsTableKey++
    },
    activityDialog(val) {
      this.activityFormKey++
    }
  },
  methods: {
    setDefaultViewFields(val) {
      this.colSelectedFieldsForTable = val.filter(a => a.defView)
    },
    updateColSelectedFields(val) {
      this.colSelectedFields = val
      if(this.colSelectedFields.length > 0)
      this.setupColumns()
    },
    updateActivities(obj) {
      this.loadingActivities = true
      if(obj && obj.quickFilters)
        obj.quickFilters["custName"] = this.$route.params.custid
        
        this.activityService
          .getMyActivities(obj.savedFilter1, obj.currentPage, obj.rows, obj.sortFieldId, obj.sortOrder, obj.query, obj.quickFilters)
          .then(response => {

            this.loadingActivities = false
            this.activities = response.data                            

          })
          .catch(err => {
            this.loadingActivities = false              
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while getting tasks and events for saved filter ${savedFilter1} and search text ${this.searchText}`,
              life: 5000,
            })
        })
    },
    confirmDeleteActivity(activity) {
      this.activity = activity;
      
      if (activity && activity.activityId) {
        this.activityService
          .deleteActivity(activity.activityId)
          .then(() => {
            this.reload()
          })
          .catch(error => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `The ${recordNoun(activity)} was not deleted. Please ensure that there are no related records such as other resulting Tasks or Events. You can set the ${recordNoun(activity)} to cancelled instead.`,
              life: 5000,
            })
          })
      }
    },
    editActivity(activity) {
      this.activity = { ...activity };
      this.activity.updatedBy = this.$store.getters['auth/getMyProfile'].id;
      this.activityDialog = true;
    },
    reload() {
      this.getCustomerActivities(this.$route.params.custid)
    },
    setupColumns() {
     let a = []
      let colOrder = 0
      this.colSelectedFields.forEach(b => {
          // 
          let c = a.find(d => d && d.dbField && d.dbField === b.dbField.dbField)
          if (!a[colOrder] && !c) {
              a[colOrder] = { 
                  ...b.dbField,
                  defWidth: b.width
              }
              ++colOrder
          }
      })
      
      if (a.length) {
          this.colSelectedFieldsForTable = a
      }
    },
    savedActivity(activity) {
      
      this.getCustomerActivities(this.$route.params.custid)
      this.activityDialog = false
    },
    close() {
      this.activityDialog = false
    },
    async getCustomerActivities(custId) {
      if (custId) {
        this.requesting = true
        // this.activities = await this.customerService.getCustomerActivities(custId)
        this.activityService
          .getMyActivities(0, 1, 25, 0, 0, '*', {
            custName: custId
          })
          .then(response => {

            this.loadingActivities = false
            this.activities = response.data                            

          })
          .catch(err => {
            this.loadingActivities = false              
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: `Error while getting tasks and events for saved filter ${savedFilter1} and search text ${this.searchText}`,
              life: 5000,
            })
        })
        this.requesting = false
      }
    },
    updateActivity() {
      
      if (!this.activity.activityId)
        this.activity.completed = false;

      this.sendingRequest = true
      activityRequest(this, 'CustomerDetail-customerActivities.vue')
    },
    editActivity(activity) {
      this.disabledArr = [
        'customer'
      ]
      this.activity = { ...activity };
      this.activity.updatedBy = this.$store.getters['auth/getMyProfile'].id;
      this.activityDialog = true;
    },
    newActivity() {
      this.activity = {
        user: this.$store.getters['auth/getMyProfile'],
        dateCreated: new Date()
      }
      this.disabledArr = [
        'customer'
      ]
      this.activity.customer = this.customer
      this.activity.mbpBranch = this.customer.mbpBranch
      this.activityDialog = true
    }
  }
};
</script>
<style scoped lang="scss">

.p-datatable .p-column-filter {
  display: none;
}

.table-header {
  display: flex;
  justify-content: space-between;
}
</style>